<template>
  <div>
    <div class="form-group">
      <label for="name">
        Nombre: <span class="text-danger">*</span>
      </label>
      <input
        :value="localProject.name"
        @input="$emit('update:name', $event.target.value)"
        @blur="v.name.$touch()"
        type="text"
        class="form-control"
        :class="{ 'is-invalid': v.name.$error }"
        id="name"
        required
      />
      <div v-if="v.name.$error" class="invalid-feedback">
        <div v-if="!v.name.required">{{ errorMessages.required }}</div>
      </div>
    </div>

    <div class="form-group">
      <label for="projectdesc">
        Descripción: <span class="text-danger">*</span>
      </label>
      <textarea
        :value="localProject.description"
        @input="$emit('update:description', $event.target.value)"
        @blur="v.description.$touch()"
        class="form-control"
        :class="{ 'is-invalid': v.description.$error }"
        id="projectdesc"
        rows="3"
        required
      ></textarea>
      <div v-if="v.description.$error" class="invalid-feedback">
        <div v-if="!v.description.required">{{ errorMessages.required }}</div>
      </div>
    </div>

    <div class="form-group">
      <label for="selectedProjectType">
        Tipo de convocatoria: <span class="text-danger">*</span>
      </label>
      <select
        :value="localProject.project_type_id"
        @change="$emit('update:project_type_id', $event.target.value)"
        @blur="v.project_type_id.$touch()"
        class="form-control"
        :class="{ 'is-invalid': v.project_type_id.$error }"
        id="selectedProjectType"
        required
      >
        <option value="">Selecciona tipo</option>
        <option
          v-for="option in selectOptionsProjectType"
          :value="option.id"
          :key="option.id"
        >
          {{ option.name }}
        </option>
      </select>
      <div v-if="v.project_type_id.$error" class="invalid-feedback">
        <div v-if="!v.project_type_id.required">{{ errorMessages.required }}</div>
      </div>
    </div>

    <div class="form-group">
      <label for="selectedStatus">
        Estado: <span class="text-danger">*</span>
      </label>
      <select
        :value="localProject.status"
        @change="$emit('update:status', $event.target.value === '' ? 1 : Number($event.target.value))"
        @blur="v.status.$touch()"
        class="form-control"
        :class="{ 'is-invalid': v.status.$error }"
        id="selectedStatus"
        required
      >
        <option value="">Selecciona estado</option>
        <option
          v-for="option in selectOptionsStatus"
          :value="option.id"
          :key="option.id"
        >
          {{ option.name }}
        </option>
      </select>
      <div v-if="v.status.$error" class="invalid-feedback">
        <div v-if="!v.status.required">{{ errorMessages.required }}</div>
      </div>
    </div>

    <div class="form-group">
      <label for="link">Enlace de la convocatoria:</label>
      <input
        :value="localProject.link"
        @input="$emit('update:link', $event.target.value)"
        type="text"
        class="form-control"
        id="link"
        placeholder="https://example.com"
      />
    </div>
  </div>
</template>

<script>
import { errorMessages } from "@/helpers/validations/errorMessages";

export default {
  name: "BasicInfoTab",
  props: {
    localProject: {
      type: Object,
      required: true,
    },
    selectOptionsProjectType: {
      type: Array,
      default: () => [],
    },
    selectOptionsStatus: {
      type: Array,
      default: () => [],
    },
    v: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      errorMessages,
    };
  },
  emits: [
    "update:name",
    "update:description",
    "update:project_type_id",
    "update:status",
    "update:link",
  ],
};
</script>
